import React from 'react';
import { Link } from 'react-router-dom';

/** Icons */
import { ReactComponent as Border } from '../../assets/svg/droplet.svg';
import { ReactComponent as Shadow } from '../../assets/svg/square.svg';

const HomeItem = ({ children, title, to }) => (
  <Link
    to={to}
    className="rounded flex items-center overflow-hidden shadow-lg text-indigo-900 text-center bg-white py-8 px-10"
  >
    {children} <strong className="text-2xl text-indigo-900">{title}</strong>
  </Link>
);
const Home = () => {
  return (
    <section className="flex xl:flex-row h-full flex-col justify-around xl:items-start items-center xl:pb-0 pb-40 w-2/3 mx-auto mt-32">
      <HomeItem to="/border-radius" title="Border Radius">
        <Border className="mr-3" />
      </HomeItem>
      <HomeItem to="/box-shadow" title="Box Shadow">
        <Shadow className="mr-3" />
      </HomeItem>
    </section>
  );
};

export default Home;
